import { createContext } from "react";

export const SurveyFormContext = createContext({
  stepsAnswers: [],
  setStepsAnswers: (v: any) => {},
  currentStep: 0,
});
